export default __webpack_public_path__ + "static/media/PPI-firefeature-019.891ae380.jpg";